<div class="preloader-area">
    <div class="spinner">
        <div class="inner">
            <img src="assets/img/logo_mentanalytics_hoja.png" alt="Company Logo" class="logo">
            <div class="disc"></div>
            <div class="disc"></div>
        </div>
    </div>
</div>
